export const moduleName = 'axp-travel-search-locations';
